var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeatix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.92 0c9.96-.082 20.154 7.075 20.31 19.25.078 8.554-5.68 14.806-13.151 16.698-2.88.576-4.202-3.784-4.67-5.182-.31-.905.312-1.563 1.012-1.646 6.07-.329 9.961-3.948 10.428-9.377.545-7.157-4.202-10.94-9.65-10.94-11.283.082-10.505 9.13-10.194 12.338.545 5.512 2.257 9.707 3.97 12.75 0 0 .544.905.544 1.152 0 .411-1.09.658-2.335.082C4.75 33.233.08 26.57.002 19.414-.154 6.664 9.496 3.784 11.597 2.386c.078 0 .233-.164.233-.411 0-.247-.155-.411-.389-.494l-.7-.164c-.234 0-.39-.247-.39-.494 0-.246.078-.411.234-.493 0 0 .39-.247 2.335-.33Zm3.501 13.738c3.19-.411 4.903 2.797 4.747 5.1-.155 2.139-1.556 4.689-6.225 5.018-1.09.082-1.868-.905-2.257-1.81-.233-.822-.467-1.727-.545-2.797-.155-1.398-.31-4.853 4.28-5.511Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeatix);
export default __webpack_public_path__ + "static/media/peatix.bd34cf6c000ac6bc8b340b087ffcd366.svg";
export { ForwardRef as ReactComponent };